import React from 'react';
import classNames from 'classnames';

import { componentIsSvg } from '../../../../utilities';

import { IconLinkListIconSize } from './types';
import type { ContentProps, InteriorProps, ButtonProps, LinkProps } from './types';

import './Content.scss';
import { SvgIconComponent } from '@/types';

export function Content({
    children,
    error = false,
    destructive = false,
    highlight = false,
    subdued = false,
}: ContentProps) {
    const contentClassNames = classNames('IconLinkList-Content', {
        // TODO: Simplify class names
        'IconLinkList-Content--error': error,
        'IconLinkList-Content--destructive': destructive,
        'IconLinkList-Content--highlight': highlight,
        'IconLinkList-Content--subdued': subdued,
    });

    return <div className={contentClassNames}>{children}</div>;
}

function Interior({ icon, iconSize = IconLinkListIconSize.Full, label }: InteriorProps) {
    const SvgIcon = icon as SvgIconComponent;
    const iconChild = componentIsSvg(icon) ? <SvgIcon /> : icon;

    const iconClassNames = classNames('IconLinkList-Icon', {
        // TODO: Simplify class names
        'IconLinkList-Icon--sizeSmall': iconSize === IconLinkListIconSize.Small,
        'IconLinkList-Icon--sizeMedium': iconSize === IconLinkListIconSize.Medium,
    });

    const labelMarkup = label ? <span className="IconLinkList-Label">{label}</span> : null;

    return (
        <div className="IconLinkList-Interior">
            <div className={iconClassNames}>{iconChild}</div>
            {labelMarkup}
        </div>
    );
}

function Button({ disabled = false, pressed = false, onAction, ...interiorProps }: ButtonProps) {
    return (
        <button
            type="button"
            className="IconLinkList-Button"
            disabled={disabled}
            aria-pressed={pressed}
            onClick={onAction}
        >
            <Interior {...interiorProps} />
        </button>
    );
}

function Link({ url, openNewTab = false, ...interiorProps }: LinkProps) {
    return (
        <a href={url} className="IconLinkList-Link" target={openNewTab ? '_blank' : undefined} rel="noreferrer">
            <Interior {...interiorProps} />
        </a>
    );
}

Content.Button = Button;
Content.Link = Link;
